import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-804bda3a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "max-w-5xl mx-auto" };
const _hoisted_2 = { class: "button-row" };
const _hoisted_3 = { class: "panel" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "panel-title" }, "クーポン詳細", -1));
const _hoisted_5 = { class: "pointinfo-wrapper" };
const _hoisted_6 = { class: "panel" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "panel-title" }, "付与対象者一覧", -1));
const _hoisted_8 = { class: "table-wrapper" };
const _hoisted_9 = { class: "result-table" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { class: "crm_customer_id" }, "顧客ID"),
        /*#__PURE__*/ _createElementVNode("th", { class: "user_name" }, "氏名"),
        /*#__PURE__*/ _createElementVNode("th", { class: "mobile_phone_number" }, "電話番号"),
        /*#__PURE__*/ _createElementVNode("th", { class: "history_date" }, "付与日時"),
        /*#__PURE__*/ _createElementVNode("th", { class: "store" }, "店舗"),
        /*#__PURE__*/ _createElementVNode("th", { class: "granted_by" }, "付与担当者")
    ])
], -1));
const _hoisted_11 = { class: "crm_customer_id" };
const _hoisted_12 = { class: "user_name" };
const _hoisted_13 = { class: "mobile_phone_number" };
const _hoisted_14 = { class: "history_date" };
const _hoisted_15 = { class: "store" };
const _hoisted_16 = { class: "granted_by" };
const _hoisted_17 = { class: "table-footer" };
const _hoisted_18 = ["disabled"];
const _hoisted_19 = { class: "page-indicator" };
const _hoisted_20 = ["disabled"];
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "modal-body" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "modal-text" }, "クーポンを削除します")
], -1));
const _hoisted_22 = { class: "button-row-modal" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Title = _resolveComponent("Title");
    const _component_CouponInfo = _resolveComponent("CouponInfo");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Title, {
            msg: "クーポン詳細",
            submsg: "Coupon Detail"
        }),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
                class: "btn-primary",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => ($options.redirectGrantCoupon && $options.redirectGrantCoupon(...args)))
            }, " クーポン一括付与 "),
            ($data.deleteId == null)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn-primary",
                    onClick: _cache[1] || (_cache[1] =
                        //@ts-ignore
                        (...args) => ($options.openModal && $options.openModal(...args)))
                }, " クーポン削除 "))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn-primary",
                    onClick: _cache[2] || (_cache[2] =
                        //@ts-ignore
                        (...args) => ($options.redirectDeleteCoupon && $options.redirectDeleteCoupon(...args)))
                }, " クーポン削除結果 "))
        ]),
        _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_CouponInfo, { coupon_code: $data.couponCode }, null, 8, ["coupon_code"])
            ])
        ]),
        _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
                _createElementVNode("table", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.pagedInfo, (r, i) => {
                            return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                _createElementVNode("td", _hoisted_11, _toDisplayString(r.crm_customer_id), 1),
                                _createElementVNode("td", _hoisted_12, _toDisplayString(r.user_name), 1),
                                _createElementVNode("td", _hoisted_13, _toDisplayString(r.mobile_phone_number), 1),
                                _createElementVNode("td", _hoisted_14, _toDisplayString(r.history_date), 1),
                                _createElementVNode("td", _hoisted_15, _toDisplayString(r.store), 1),
                                _createElementVNode("td", _hoisted_16, _toDisplayString(r.granted_by), 1)
                            ]));
                        }), 128))
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                    class: "pg-btn",
                    disabled: $data.infoPage <= 1,
                    onClick: _cache[3] || (_cache[3] = ($event) => ($options.setInfoPage($data.infoPage - 1)))
                }, " ‹ ", 8, _hoisted_18),
                _createElementVNode("div", _hoisted_19, _toDisplayString($data.infoPage) + " / " + _toDisplayString($options.infoTotalPages), 1),
                _createElementVNode("button", {
                    class: "pg-btn",
                    disabled: $data.infoPage >= $options.infoTotalPages,
                    onClick: _cache[4] || (_cache[4] = ($event) => ($options.setInfoPage($data.infoPage + 1)))
                }, " › ", 8, _hoisted_20)
            ])
        ]),
        ($data.show)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "modal-overlay",
                onClick: _cache[8] || (_cache[8] =
                    //@ts-ignore
                    (...args) => ($options.closeModal && $options.closeModal(...args)))
            }, [
                _createElementVNode("div", {
                    class: "modal-dialog",
                    onClick: _cache[7] || (_cache[7] = _withModifiers(() => { }, ["stop"])),
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "modal-title"
                }, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("button", {
                            class: "btn-secondary",
                            onClick: _cache[5] || (_cache[5] =
                                //@ts-ignore
                                (...args) => ($options.closeModal && $options.closeModal(...args)))
                        }, "戻る"),
                        _createElementVNode("button", {
                            class: "btn-primary",
                            onClick: _cache[6] || (_cache[6] =
                                //@ts-ignore
                                (...args) => ($options.deleteCoupon && $options.deleteCoupon(...args)))
                        }, "削除")
                    ])
                ])
            ]))
            : _createCommentVNode("", true)
    ]));
}
